if (!customElements.get('ly-showroom-form')) {
    class LyShowroomForm extends HTMLElement {

        connectedCallback() {
            this.form = this.querySelector('form')
            this.spinner = this.querySelector('.loading__spinner')

            this.form.addEventListener('submit', this.submitHandler)
        }

        submitHandler = async (evt) => {
            evt.preventDefault()
            const fd = new FormData(this.form)
            const form = {}
            fd.entries().forEach(([k, v]) => {
                form[k] = v
            })
            form.roomId = location.pathname.replace('/pages/showroom-form/', '')
            try {
                this.spinner.classList.toggle('hidden')

                await API.requestShowroomVisit(form)

                this.classList.add('is-success')
            } catch (error) {
                console.error(error)
            } finally {
                this.spinner.classList.toggle('hidden')
            }
        }

        disconnectedCallback() {
            this.form.removeEventListener('submit', this.submitHandler)
        }
    }

    customElements.define('ly-showroom-form', LyShowroomForm)
}